package network

import org.koin.dsl.module
import websocket.WebsocketService

fun networkKoinModule() = module {
    single { NetworkStateStore() }
    single { NetworkInformationStore() }
    single { WebsocketService() }
}